import { render, staticRenderFns } from "./range-period.vue?vue&type=template&id=7637a40b&"
import script from "./range-period.vue?vue&type=script&lang=js&"
export * from "./range-period.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RangeSlider: require('/var/www/components/range/range-slider.vue').default})
